<router-outlet></router-outlet>

<app-navbar *ngIf="showNavigation$ | async"></app-navbar>
